import BG from "../assets/about_bg1.JPG";
import bawa from "../assets/bawa.png";
import dooland from "../assets/dooland_de_silva.png";
import dan from "../assets/dan_de_silva.png";
import about1 from "../assets/about1.jpg";
import about2 from "../assets/about2.jpg";
import about3 from "../assets/about3.jpg";
import about4 from "../assets/about4.jpg";
import Bevis_Bawa from "../assets/Bevis_Bawa.jpg";
import about_old from "../assets/about_old.jpeg";
import TopSection from "../components/topSection";
import "../styles/aboutus.css";
import { useNavigate } from "react-router-dom";

function About() {
  const navigate = useNavigate();
  return (
    <>
      <TopSection image={BG} text={"About us"} backgroundPositionY={"43%"} />
      <section className="light-bg py-5">
        <div className="visit-container container ">
          <div class="plan-section row m-0 px-0 py-5">
            <div class="plan-title col-4">
              History and Evolution of Brief Garden
            </div>
            <div class="plan-description row col-8">
              <div className="col-md-6">
                <p className="plain_text">
                  Brief is the home of late bevis bawa (1909–1992) in beruwala
                  sri lanka. Brief had been landscaped by the owner Bevis Bawa
                  over period of seven decades. It is now the home of the
                  landscape design practice Brief Garden Designs.
                </p>
                <p className="plain_text">
                  In 1929 Bawa was bequeathed the family rubber plantation by
                  his mother, Bertha Marianne née Schrader (1876–1946). The
                  original estate was approximately 81 hectares (200 acres) with
                  Bevis Bawa selling off portions of the estate to reduce it to
                  manageable proportions & with that money he travelled the
                  world over.
                </p>
                <p className="plain_text">
                  He was influenced by his travels to build this wonderful,
                  garden, which was opened to the public in 1969. Eversince it
                  has been visited by many foreign
                </p>
              </div>

              <div className="col-md-6">
                <p className="plain_text">
                  and local tourists & students from around the world including
                  celebrities such as Vivien Leigh, Peter finch, Sir Laurence
                  Olivier and the royalty such as Queen Ingrid, (The Late Queen
                  Mother of Denmark). Brief was the home, to many local &
                  foreign Artists such as Donald Friend, Barbara Sansoni, Laki
                  Senanayake, and visited by many local & foreign artists like
                  Russel Drysdale. Bevis continued to work on the garden until
                  he lost his sight in late 1980’s. Bevis passed away in 1992.
                </p>
                <p className="plain_text">
                  The estate was inherited by Dooland de Silva, which was passed
                  on to his son Dan de Silva in 2022.
                </p>
                <p className="plain_text">
                  Brief was identified and featured on “THE GREAT GARDENS OF THE
                  WORLD” since 2019.
                </p>
              </div>
            </div>
          </div>
          <div className="row py-5">
            <div className="col-3 p-2">
              
              <div className="about_top_img_wrapper_t">
                <img className="w-100" src={about1} alt="brief history" />
              </div>
            </div>
            <div className="col-3 p-2">
              
              <div className="about_top_img_wrapper_t">
                <img className="w-100" src={about2} alt="brief history" />
              </div>
            </div>
            <div className="col-3 p-2">
              
              <div className="about_top_img_wrapper_t">
                <img className="w-100" src={about3} alt="brief history" />
              </div>
            </div>
            <div className="col-3 p-2">
              
              <div className="about_top_img_wrapper_t">
                <img className="w-100" src={about4} alt="brief history" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="dark-bg">
        <div className="container py-5">
          <div className="row mt-5">
            <div className="col-12 col-md-7">
              <p className="light-text ">
                “A Paradise, made by the sensibility of one man, created by his
                patience and love.”
              </p>
            </div>
            <div className="col-12 col-md-5 ps-1">
              <p className="section-header light-text text-end">
                About Bevis Bawa
              </p>
            </div>
            <div className="col-12 col-md-6  mt-md-5  ">
              <div class="parent h-100">
                <div class="div1 p-2" style={{ backgroundImage: `url(${Bevis_Bawa})` }}>
                 
                </div>
                <div class="div2 p-2" style={{ backgroundImage: `url(${about_old})` }}>
                  
                </div>
                <div class="div3 p-2" style={{ backgroundImage: `url(${BG})` }}>
                
                </div>
              </div>
            </div>
            <div
              className="col-12 col-md-6  mt-md-5 light-text  "
              style={{ textAlign: "justify" }}
            >
              <div>
                <p className="plain_text">
                  Bevis Bawa was not merely the creator of Brief Garden, he was
                  its soul. A towering presence in Sri Lanka’s cultural history,
                  Bevis was a self-taught landscape designer, artist, raconteur,
                  and aesthete whose life defied norms and whose vision helped
                  shape the artistic and horticultural identity of 20th century
                  Sri Lanka.
                </p>
                <p className="plain_text">
                  Born into a wealthy Anglo-Ceylonese family, Bevis was the
                  elder brother of the internationally acclaimed architect
                  Geoffrey Bawa. Where Geoffrey brought discipline and restraint
                  to design, Bevis embodied spontaneity, wit, and extravagance.
                  The contrast between the two was stark, but both played a
                  pivotal role in defining tropical modernism in their own
                  unique ways — Geoffrey through architecture, and Bevis through
                  landscape and garden art.
                </p>
              </div>
              <div className="d-flex px-3 justify-content-end align-items-end mt-5">
                <div style={{ height: "fit-content" }}>
                  <button className="btn-bawa primary-light-btn" onClick={() => navigate("/bevis_bawa")}>
                    see more
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="light-bg py-5">
        <div className="visit-container container">
          <div class="plan-section row m-0 p-0">
            <div class="plan-title col-4">Carrying Forward the Heritage</div>
            <div class="plan-description row col-8">
              <div className="col-md-6">
                <p className="plain_text">
                  Following the passing of Bevis Bawa in 1992, the care and
                  preservation of Brief Garden were inherited to Dooland de
                  Silva, Bawa’s longtime associate and head gardener. Having
                  worked closely with Bevis for many years, Dooland upheld the
                  artistic vision and horticultural integrity of the garden with
                  deep dedication and personal knowledge.
                </p>
              </div>

              <div className="col-md-6">
                <p className="plain_text">
                  In 2022, the estate was inherited by his son, Dan de Silva,
                  who now oversees the continued maintenance, restoration, and
                  public engagement of the garden. Under Dan’s guidance, Brief
                  Garden remains open to visitors from around the world and
                  continues to serve as a space of creativity, tranquility, and
                  cultural heritage.
                </p>
              </div>
            </div>
          </div>
          <div className="row px-md-5 gap-5 py-5">
            <div className="col-md-3 ms-auto  p-2">
              
              <div className="about_top_img_wrapper">
                <img className="w-100" src={bawa} alt="Bevis Bawa" />
                <div className="about_top_img_text_wrapper">
                  <p className="about_top_img_text m-0">Bevis Bawa</p>
                </div>
              </div>
            </div>
            <div className="col-md-3  p-2">
              
              <div className="about_top_img_wrapper">
                <img className="w-100" src={dooland} alt="Dooland de Silva" />
                 <div className="about_top_img_text_wrapper">
                  <p className="about_top_img_text m-0">Dooland de Silva</p>
                </div>
              </div>
              
            </div>
            <div className="col-md-3 me-auto p-2">
              
              <div className="about_top_img_wrapper">
                <img className="w-100" src={dan} alt="Dan de Silva" />
                 <div className="about_top_img_text_wrapper">
                  <p className="about_top_img_text m-0">Dan de Silva</p>
                </div>
              </div>
            </div>
            <div className="col-10">
                <video src="https://www.briefgarden.lk/wp-content/uploads/2022/01/Bevis-Bawa.mp4"></video>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
